import { Check } from "lucide-react";

export function BookingStepProgress({ step, steps }) {
  return (
    <div className="flex items-center justify-center mb-6 sm:mb-10 overflow-x-auto pb-2">
      {steps.map((s, idx) => (
        <div key={s.num} className="flex items-center">
          <div 
            className={`flex flex-col items-center ${step >= s.num ? 'text-green-600' : 'text-muted-foreground'}`}
          >
            <div 
              className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-xs sm:text-sm transition-colors ${
                step >= s.num 
                  ? 'bg-green-600 text-white' 
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {step > s.num ? <Check className="w-4 h-4 sm:w-5 sm:h-5" /> : s.num}
            </div>
            <span className="text-[10px] sm:text-xs mt-1 hidden sm:block whitespace-nowrap">{s.title}</span>
          </div>
          {idx < steps.length - 1 && (
            <div className={`w-6 sm:w-12 md:w-20 h-1 mx-1 sm:mx-2 rounded ${step > s.num ? 'bg-green-600' : 'bg-muted'}`} />
          )}
        </div>
      ))}
    </div>
  );
}
